var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',[(_vm.loaded)?_c('div',{staticClass:"custom-table-container tableContainer"},[_c('ServiceCatalog',{attrs:{"store":_vm.servicesAnalytics,"tab-key":"analytics"},on:{"selector-initialized":_vm.onSelectorInitialized}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }